export const ODDS_FORMATS = ["decimal", "fractional", "american"] as const;
export type OddsFormat = (typeof ODDS_FORMATS)[number];

/** The closest n/d to `value` with d up to `maxDenominator` (continued fractions). */
const toFraction = (value: number, maxDenominator = 100): [number, number] => {
  let [h0, h1, k0, k1] = [0, 1, 1, 0];
  let x = value;
  for (let i = 0; i < 20; i++) {
    const a = Math.floor(x);
    const h2 = a * h1 + h0;
    const k2 = a * k1 + k0;
    if (k2 > maxDenominator) break;
    [h0, h1, k0, k1] = [h1, h2, k1, k2];
    if (Math.abs(x - a) < 1e-9) break;
    x = 1 / (x - a);
  }
  return [h1, k1 || 1];
};

/**
 * A decimal price in the player's format. Fractional is the profit per unit as the
 * nearest simple fraction (1.91 → 10/11); American is +profit per 100 staked for prices
 * of 2.00 and up, and −stake needed to win 100 below.
 */
export const formatOddsValue = (decimal: number, format: OddsFormat): string => {
  if (!Number.isFinite(decimal) || decimal <= 1) return "";
  if (format === "fractional") {
    const [numerator, denominator] = toFraction(decimal - 1);
    return `${numerator}/${denominator}`;
  }
  if (format === "american") {
    return decimal >= 2
      ? `+${Math.round((decimal - 1) * 100)}`
      : `-${Math.round(100 / (decimal - 1))}`;
  }
  return decimal.toFixed(2);
};
